"use strict";Object.defineProperty(exports,"__esModule",{value:!0}),exports.version=void 0,exports.version="1.32.0";